import React from 'react';

import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';
import StaticPage from '../../containers/StaticPage/StaticPage';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import Collapsible from 'react-collapsible';
import { GoTriangleDown } from 'react-icons/go';
import css from './FaqPage.module.css';

import { useIntl } from 'react-intl';

const FaqPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  const intl = useIntl();
  return (
    <StaticPage
      title="Faq"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'Faq',
        description: 'Faq ',
        name: 'Faq page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <h2 className={css.pageTitle}>faq</h2>
          <Collapsible
            trigger={
              <label htmlFor="text" className={css.trigger}>
                <div className={css.triggerText}>
                  <h3 className={css.question}>What is loyalty-test.com?</h3>
                </div>
                <div className={css.iconContainer}>
                  <GoTriangleDown className={css.downIcon} />
                </div>
              </label>
            }
            transitionTime={300}
          >
            <div className={css.collapsibleBody}>
              <div>
                <p>
                  Loyalty-test.com is a website where users can sign up to have testers test the
                  loyalty of their partner. The testers will contact your partner on social media or
                  flirt with them at a bar/club to see how they respond.
                </p>
              </div>
            </div>
          </Collapsible>
          <Collapsible
            trigger={
              <label htmlFor="text" className={css.trigger}>
                <div className={css.triggerText}>
                  <h3 className={css.question}>How does it work?</h3>
                </div>
                <div className={css.iconContainer}>
                  <GoTriangleDown className={css.downIcon} />
                </div>
              </label>
            }
            transitionTime={300}
          >
            <div className={css.collapsibleBody}>
              <div>
                <p>
                  To use our service, you will need to sign up for an account on our website, choose
                  one of our many testers, and then provide necessary information including their
                  social media handles and any specific instructions you may have. Our testers will
                  then contact your partner and follow your instructions to test their loyalty.
                </p>
              </div>
            </div>
          </Collapsible>
          <Collapsible
            trigger={
              <label htmlFor="text" className={css.trigger}>
                <div className={css.triggerText}>
                  <h3 className={css.question}>Is it legal?</h3>
                </div>
                <div className={css.iconContainer}>
                  <GoTriangleDown className={css.downIcon} />
                </div>
              </label>
            }
            transitionTime={300}
          >
            <div className={css.collapsibleBody}>
              <div>
                <p>
                  Yes, our service is completely legal. We take privacy and consent very seriously,
                  and all we want to make sure everyone is treated fairly and with respect.
                </p>
              </div>
            </div>
          </Collapsible>
          <Collapsible
            trigger={
              <label htmlFor="text" className={css.trigger}>
                <div className={css.triggerText}>
                  <h3 className={css.question}>How much does it cost?</h3>
                </div>
                <div className={css.iconContainer}>
                  <GoTriangleDown className={css.downIcon} />
                </div>
              </label>
            }
            transitionTime={300}
          >
            <div className={css.collapsibleBody}>
              <div>
                <p>
                  The cost of our service depends on the specific details of your request and what
                  the specific tester charges.
                </p>
              </div>
            </div>
          </Collapsible>
          <Collapsible
            trigger={
              <label htmlFor="text" className={css.trigger}>
                <div className={css.triggerText}>
                  <h3 className={css.question}>Is the information I provide confidential?</h3>
                </div>
                <div className={css.iconContainer}>
                  <GoTriangleDown className={css.downIcon} />
                </div>
              </label>
            }
            transitionTime={300}
          >
            <div className={css.collapsibleBody}>
              <div>
                <p>
                  Yes,, all of the information you provide to us will be kept strictly confidential.
                  We will never share your personal information with any third parties without your
                  explicit consent.
                </p>
              </div>
            </div>
          </Collapsible>
          <Collapsible
            trigger={
              <label htmlFor="text" className={css.trigger}>
                <div className={css.triggerText}>
                  <h3 className={css.question}>Can I trust the results of the loyalty test?</h3>
                </div>
                <div className={css.iconContainer}>
                  <GoTriangleDown className={css.downIcon} />
                </div>
              </label>
            }
            transitionTime={300}
          >
            <div className={css.collapsibleBody}>
              <div>
                <p>
                  Yes, we strive to provide accurate and reliable results, but please keep in mind
                  that the test is not a guarantee of your partner's loyalty. It is simply one tool
                  that you can use to help you understand your relationship better.
                </p>
              </div>
            </div>
          </Collapsible>
          <Collapsible
            trigger={
              <label htmlFor="text" className={css.trigger}>
                <div className={css.triggerText}>
                  <h3 className={css.question}>What should I do if I have more questions?</h3>
                </div>
                <div className={css.iconContainer}>
                  <GoTriangleDown className={css.downIcon} />
                </div>
              </label>
            }
            transitionTime={300}
          >
            <div className={css.collapsibleBody}>
              <div>
                <p>
                  Check out our full list of frequently asked questions{' '}
                  <a
                    href="https://intercom.help/loyalty-test-inc/en/articles/11109900-frequently-asked-questions"
                    target="_blank"
                    rel="noopener"
                  >
                    here
                  </a>
                  .
                </p>
              </div>
            </div>
          </Collapsible>
          <Collapsible
            trigger={
              <label htmlFor="text" className={css.trigger}>
                <div className={css.triggerText}>
                  <h3 className={css.question}>Even more questions?</h3>
                </div>
                <div className={css.iconContainer}>
                  <GoTriangleDown className={css.downIcon} />
                </div>
              </label>
            }
            transitionTime={300}
          >
            <div className={css.collapsibleBody}>
              <div>
                <p>
                  If you have any additional questions about our service, please don't hesitate to
                  contact us through email
                  <a href={'mailto:contact@loyalty-test.com'}> contact@loyalty-test.com</a>
                </p>
              </div>
            </div>
          </Collapsible>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default FaqPage;
